import axiosPost from '../axiosPost';

export const eventosDeSesionDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "EventoDeSesionDel",
        "params": { "eventoSesionId": id }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
};